import { useMemo } from 'react';

interface StringListFieldProps {
  label?: string;
  value: string[];
  onChange: (items: string[]) => void;
  placeholder?: string;
  helperText?: string;
  rows?: number;
}

/**
 * Edits a string array as a textarea with one item per line. Used for the
 * gallery, overview, benefits and tags of website content.
 */
export function StringListField({
  label,
  value,
  onChange,
  placeholder,
  helperText,
  rows = 4,
}: StringListFieldProps) {
  const text = useMemo(() => (value || []).join('\n'), [value]);

  return (
    <div>
      {label && <label className="block text-sm font-medium text-text mb-1">{label}</label>}
      <textarea
        value={text}
        rows={rows}
        placeholder={placeholder}
        onChange={(e) =>
          onChange(
            e.target.value
              .split('\n')
              .map((line) => line.trim())
              .filter((line) => line.length > 0),
          )
        }
        className="w-full px-3 py-2 border border-border rounded-lg bg-background text-text focus:outline-none focus:ring-2 focus:ring-primary text-sm font-mono"
      />
      {helperText && <p className="text-xs text-text-muted mt-1">{helperText}</p>}
    </div>
  );
}
